// #region Dependencias
import styled from 'styled-components'
import { InputLabel, TextError } from 'components/Library'
import { colors } from 'components/Library/theme'
import { StyledInputContainer } from './Input'
// #endregion

// #region Estilos
const StyledSelect = styled.select`
  appearance: none;
  background-color: transparent;
  background-image: linear-gradient(45deg, transparent 50%, ${colors.white} 50%),
    linear-gradient(135deg, ${colors.white} 50%, transparent 50%),
    linear-gradient(to right, ${colors.primary}, ${colors.primary});
  background-position: calc(100% - 24px) 1.3rem, calc(100% - 12px) 1.3rem, 100% 0;
  background-repeat: no-repeat;
  background-size: 12px 12px, 12px 12px, 3rem 100%;
  border: 2px solid ${colors.primary};
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 1rem;
  width: 100%;
`

const StyledOption = styled.option``
// #endregion

/**
 * Componente para renderizar un campo de selección con sus respectivas opciones.
 *
 * @class
 * @example
 * const PAISES = [{
 *  value: 'CO,
 *  label: "Colombia"
 * }]
 *
 * return (
 *  <InputSelect error="Opción invalida" helper="Seleccionar país" label="País" name="pais" value="valor" options={PAISES} onChange={handleInputChange} />
 * )
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.className=null] - Clase CSS para aplicar al selector.
 * @param {string} props.error - Mensaje de error a mostrar debajo del campo.
 * @param {string} [props.helper=null] - Texto de ayuda del campo.
 * @param {string} props.label - Texto de la etiqueta del campo.
 * @param {string} props.name - Nombre del campo, utilizado como valor del atributo 'htmlFor' de la etiqueta.
 * @param {string} props.value - Valor actual del campo.
 * @param {Array.<{value: string, label: string}>} props.options - Arreglo de opciones para el selector.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 * @param {Function} onChange - Callback que se ejecuta al modificar el valor del campo.
 */

const InputSelect = ({
  className,
  error,
  helper,
  label,
  name,
  options,
  value,
  children,
  ...props
}) => {
  return (
    <StyledInputContainer>
      <InputLabel helper={helper} htmlFor={name} label={label} value={value} />
      <StyledSelect id={name} name={name} value={value} {...props}>
        {children}
        <StyledOption disabled value={0}>
          Seleccionar...
        </StyledOption>
        {options.map((opt, index) => (
          <StyledOption key={index} value={opt.value}>
            {opt.label}
          </StyledOption>
        ))}
      </StyledSelect>
      <TextError error={error} />
    </StyledInputContainer>
  )
}

export default InputSelect
